import { render, staticRenderFns } from "./EModalJustificarFaltaProfessorPlanejamento.vue?vue&type=template&id=6c4a2c3b&scoped=true"
import script from "./EModalJustificarFaltaProfessorPlanejamento.vue?vue&type=script&lang=js"
export * from "./EModalJustificarFaltaProfessorPlanejamento.vue?vue&type=script&lang=js"
import style0 from "./EModalJustificarFaltaProfessorPlanejamento.vue?vue&type=style&index=0&id=6c4a2c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4a2c3b",
  null
  
)

export default component.exports